<template>
  <div class="location-search" :class="{'inline': showInline}">
    <div class="location-title">
      <span class="spain-icon"></span>
      {{t('busqueda_por_zona')}}
    </div>
    <div class="search-container">
      <v-select
        class="search-input"
        @search="debouncedSearch"
        :filterable="false"
        :options="suggestions"
        @input="onSelectLocation"
        :placeholder="t('search_placeholder')"
      >
        <template slot="no-options">
          <span v-if="isSearching">{{t('buscando')}}</span>
          <span v-if="!isSearching && query.length >= 3">{{t('no_results')}}</span>
          <span v-if="!isSearching && query.length < 3">{{t('type_more')}}</span>
        </template>
        <template slot="option" slot-scope="option">
          <div class="dropdown-option" v-html="highlightText(option.value) + (option.parent_value ? ' (' + option.parent_value + ')' : '') + ' - ' + t(option.glk.toLowerCase())"></div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="dropdown-option selected">{{option.value}}{{option.parent_value ? ' (' + option.parent_value + ')' : ''}} - {{t(option.glk.toLowerCase())}}</div>
        </template>
      </v-select>
    </div>
    <div
      class="btn btn-navigate"
      v-bind:class="{disabled : !selectedLocation}"
      @click="applySelection"
    >{{buttonLabel}}</div>

    <!--<input v-model="query" @input="searchLocation">
    <ul>
      <li v-for="item in suggestions" :key="item.id">
        <router-link :to="item.id"> {{item.value}}</router-link>
      </li>
    </ul>-->
  </div>
</template>

<script>
import Api from '@/api'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import { mapState } from 'vuex'
const debounce = require('debounce');

export default {
  name: 'LocationSearch',
  props: ['showInline', 'buttonLabel'],
  components: {
    vSelect
  },
  data () {
    return {
      selectedLocation: null,
      query: '',
      suggestions: [],
      isSearching: false
    }
  },
  methods: {
    debouncedSearch: debounce(function (query, loadingFn){
      debounce(this.searchLocation(query, loadingFn))
    },600),
    searchLocation (query, loadingFn) {
      this.query = query
      if (query.length >= 3) {
        loadingFn(true)
        this.isSearching = true
        Api.searchLocation(query).then(res => {
          this.suggestions = res.suggestions
          loadingFn(false)
          this.isSearching = false
        })
      } else {
        this.suggestions = []
        this.isSearching = false
      }
    },
    highlightText (value) {
      var iQuery = new RegExp(this.query, "ig");
      return value.toString().replace(iQuery, function(matchedTxt,a,b){
          return ('<span class=\'highlight\'>' + matchedTxt + '</span>');
      });
    },
    onSelectLocation (item) {
      this.selectedLocation = item
    },
    applySelection() {
      this.$emit('change', this.selectedLocation)
    }
  },
  computed:{
    ...mapState(['nodeInfo'])
  }
}
</script>

<style lang="stylus" scoped>
.location-search
  padding: 0px
  display flex
  flex-direction column
  &.inline
    flex-direction row
    align-items center
    .location-title
      flex 0 0 auto
      margin: 0 vw(10px)
    .search-container
      flex 1 1 auto
      margin: 0 vw(10px)
      max-width vw(380px)
    .btn-navigate
      min-height vh(40px)
      max-height vh(40px)

  .location-title
    display: flex
    justify-content: center
    justify-items: center
    margin-bottom: vh(15px)
    font-style italic
    .spain-icon
      background-image: url("~@/assets/icons/spain-map.png")
      background-position: center center
      background-repeat: no-repeat
      background-size: contain
      display: inline-block
      height: vh(22px)
      margin-right: vw(15px)
      width: vw(30px)

  .search-container
    margin-bottom: vh(10px)

  .btn-navigate
    margin-bottom: vh(10px)
    text-transform: capitalize
</style>

<style lang="stylus">
.highlight
  font-weight: $fw-bold

.search-input
  margin-bottom: vh(10px)
  max-height vh(40px)
  input
    font-family: "Lato"
    m-font-size(14,17)
    font-weight $fw-bold
    max-height vh(40px)
    min-height vh(40px)
    margin 0px
    &::placeholder
      opacity 0.25
      font-style italic
  .vs__dropdown-toggle, .vs__dropdown-menu 
    font-family: "Lato"
    m-font-size(14,17)
    background-color: #fff
    border: none
    border-radius: 0
  .vs__dropdown-toggle
    padding 0px 4px
  .vs__selected
    m-font-size(14,17)
  .vs__actions
    padding 0px 6px
    max-height vh(40px)
  .vs__open-indicator
    display none
  .vs__search
    border: none
    height: vh(40px)
</style>